import axios from "../axios";
import { downloadHsePdfBlob, raiseHsePdfRequestError } from "./downloadPdf";

const TILTAK_PATH = "/hse/tiltak";

function unwrap(response) {
  return response.data?.data || response.data;
}

function raiseApiError(error) {
  const errors = error?.response?.data?.errors;
  const message = Array.isArray(errors)
    ? errors.join(", ")
    : error?.response?.data?.message || error?.message || "error";
  const next = new Error(message);
  next.response = error?.response;
  throw next;
}

export async function fetchHseTiltak(params = {}) {
  try {
    const response = await axios.get(TILTAK_PATH, { params });
    return {
      data: response.data?.data || [],
      meta: response.data?.meta || {},
    };
  } catch (error) {
    raiseApiError(error);
  }
}

export async function fetchHseTiltakItem(id) {
  try {
    const response = await axios.get(`${TILTAK_PATH}/${id}`);
    return unwrap(response);
  } catch (error) {
    raiseApiError(error);
  }
}

export async function createHseTiltak(payload) {
  try {
    const response = await axios.post(TILTAK_PATH, { tiltak: payload });
    return unwrap(response);
  } catch (error) {
    raiseApiError(error);
  }
}

export async function updateHseTiltak(id, payload) {
  try {
    const response = await axios.put(`${TILTAK_PATH}/${id}`, { tiltak: payload });
    return unwrap(response);
  } catch (error) {
    raiseApiError(error);
  }
}

export async function deleteHseTiltak(id) {
  try {
    const response = await axios.delete(`${TILTAK_PATH}/${id}`);
    return response.data;
  } catch (error) {
    raiseApiError(error);
  }
}

export async function startHseTiltak(id) {
  try {
    const response = await axios.post(`${TILTAK_PATH}/${id}/start`);
    return unwrap(response);
  } catch (error) {
    raiseApiError(error);
  }
}

export async function completeHseTiltak(id) {
  try {
    const response = await axios.post(`${TILTAK_PATH}/${id}/complete`);
    return unwrap(response);
  } catch (error) {
    raiseApiError(error);
  }
}

export async function exportHseTiltakPdf(id, filename) {
  try {
    const response = await axios.get(`${TILTAK_PATH}/${id}/export_pdf`, {
      responseType: "blob",
      headers: { Accept: "application/pdf" },
    });
    await downloadHsePdfBlob(response.data, filename || `hse-tiltak-${id}.pdf`);
  } catch (error) {
    await raiseHsePdfRequestError(error);
  }
}
